export default __webpack_public_path__ + "static/media/2.55593124.png";